import { ReactNode } from "react";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import svLocale from "date-fns/locale/sv";

import CoreProviders from "../core";
import WorkoutsProvider from "./workouts";
import UsersProvider from "./users";
import FilterProvider from "./filterprovider";
import WorkoutSettingsProvider from "./workout-settings";

export default function Providers({ children }: { children: ReactNode }) {
  return (
    <CoreProviders>
      <LocalizationProvider dateAdapter={AdapterDateFns} locale={svLocale}>
        <WorkoutSettingsProvider>
          <WorkoutsProvider>
            <UsersProvider>
              <FilterProvider>
                {children}
              </FilterProvider>
            </UsersProvider>
          </WorkoutsProvider>
        </WorkoutSettingsProvider>
      </LocalizationProvider>
    </CoreProviders>
  );
}
